'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.equals = exports.moveFrom = exports.getDistance = exports.round = exports.reverseTranslate = exports.difference = exports.translate = exports.scale = exports.getPoint = undefined;

var _geometry = require('./jointjs/geometry');

var _geometry2 = _interopRequireDefault(_geometry);

var _geometryUtils = require('./geometryUtils');

var geometryUtils = _interopRequireWildcard(_geometryUtils);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Lib
var getPoint = exports.getPoint = function getPoint(x, y) {
    return { x: x, y: y };
};

// Utils
var scale = exports.scale = geometryUtils.scale;
var translate = exports.translate = geometryUtils.translate;
var difference = exports.difference = geometryUtils.difference;
var reverseTranslate = exports.reverseTranslate = difference;
var round = exports.round = geometryUtils.roundVals;

var getDistance = exports.getDistance = function getDistance(point1, point2) {
    var jjsPoint1 = _geometry2.default.point(point1);
    return jjsPoint1.distance(point2);
};

var moveFrom = exports.moveFrom = function moveFrom(mobilePoint, staticPoint, distance) {
    var jjsMobilePoint = _geometry2.default.point(mobilePoint);
    return geometryUtils.roundUpVals(jjsMobilePoint.move(staticPoint, distance));
};

var equals = exports.equals = function equals(point1, point2) {
    return point1.x === point2.x && point1.y === point2.y;
};


//////////////////
// WEBPACK FOOTER
// ./src/common/maths/geometry/point.js
// module id = 50
// module chunks = 0